import { render, staticRenderFns } from "./NotificationQueue.vue?vue&type=template&id=0fe3bcf5&scoped=true&"
import script from "./NotificationQueue.vue?vue&type=script&lang=js&"
export * from "./NotificationQueue.vue?vue&type=script&lang=js&"
import style0 from "./NotificationQueue.vue?vue&type=style&index=0&id=0fe3bcf5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe3bcf5",
  null
  
)

export default component.exports